// src/Components/Tournaments/AddTournament.jsx
import React, { useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { useNavigate  } from "react-router-dom";
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import { useAuth } from "../../Context/AuthContext";
import "./AddTournament.css";

const API = process.env.REACT_APP_API;

function AddTournament() {

  const navigate = useNavigate();
  const { token } = useAuth();
  
  const [form, setForm] = useState({
    showOnSite: true,
  });
  
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
        // שליחה ל־ backend
      await axios.post(`${API}/api/tournaments`, form,
        {
        headers: {
          "Authorization": `Bearer ${token}`, // 👈 חובה
        },
      });
      toast.success('✅ הטורניר נוסף בהצלחה!');
      navigate(`/tournaments`); // חזרה לרשימה אחרי שמירה

    } catch (err) {
        console.error("שגיאה בהוספת הטורניר:", err);
        toast.error('❌ הוספת הטורניר נכשלה');
    } finally {
        setLoading(false);
    }
  };

  return (
    <div className="add-tournament-form">
      {/* אייקון הבית בפינה שמאלית עליונה */}
      <div className="home-icon">
        <IoHome title="עמוד הבית" size={30} onClick={() => navigate("/")}/>
      </div>
      <div className="back-icon">
        <PiKeyReturnFill title="חזרה לעמוד הקודם" size={40} onClick={() => navigate("/tournaments")}/>
      </div>

      <h3>➕ הוספת טורניר חדש</h3>
      
      <form className="form-grid" onSubmit={handleSubmit}>
        <label>שם הטורניר:</label>
        <input
          type="text"
          name="name"
          placeholder="הכנס שם הטורניר"
          value={form.name}
          onChange={handleChange}
          required
        />
        <div className="checkbox-group">
          <label>
            <input
              type="checkbox"
              name="showOnWebsite"
              checked={form.showOnWebsite}
              onChange={handleChange}
            />
            מוצג באתר
          </label>
        </div>
        <div className="buttons">
          <button type="submit" disabled={loading}>
            {loading ? "טוען..." : "הוסף טורניר"}
          </button>
          <button onClick={() => navigate(`/tournaments`)}>⬅️ חזרה</button>
        </div>
      </form>
    </div>
  );
}

export default AddTournament;
